import axios from '../utils/axios'

export function request(functionId, body) {
  let data = {
    functionId,
    body,
  }
  return axios.request({
    data: data,
    method: 'post'
  })
}


// 2.1 搜索疾病百科信息
export function pageDiseaseInfoDraftList(body) {
  return request('health_cmp_pageDiseaseInfoDraftList', body);
}



// 2.7 更改疾病百科上下线状态
export function updateDiseaseStatus(body) {
  return request('health_cmp_health_cmp_updateDiseaseStatus', body);
}

// 2.12 通过文章id获取疾病预览信息
export function getContentPreviewInfo(body) {
  return request('health_cmp_getContentPreviewInfo', body);
}
// 2.11 获取驳回理由
export function getAuditReason(body) {
  return request('health_cmp_getAuditReason', body);
}
// 2.6 更改疾病百科审核状态
export function updateDiseaseAuditStatus(body) {
  return request('health_cmp_updateDiseaseAuditStatus', body);
}


// 2.10 搜索编审医生信息
export function searchEditreviewDoctor(body) {
  return request('health_cmp_searchEditreviewDoctor', body);
}

// 获取通用标签
export function listTenantContentLabels(body) {
  return request("health_cmp_biz_pageAuditLabels", body);
}
// 获取症状部位
export function healthCmpQueryBodyParts(body) {
  return request('health_cmp_queryBodyParts', body);
}

// 获取富文本编辑器key
export function getCEditorApiKey(body) {
  return request('jdh_queryMobileProperties', body);
}
